import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';
import { EChartsOption, ECharts } from 'echarts';

@Component({
  selector: 'c-chart',
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.css',
  standalone: false,
})
export class ChartComponent {
  private el = inject(ElementRef);
  private resizeObserver?: ResizeObserver;

  @Output() chartClick = new EventEmitter<any>();

  @Input() chartOption: EChartsOption = {
    title: {
      text: 'Distribución de Servicios',
      subtext: 'Cantidad de registros por tipo de servicio',
      left: 'start',
      top: '0%',
      textStyle: {
        fontSize: 25,
        fontWeight: 'bold',
        color: '#333', // Color del título principal
      },
      subtextStyle: {
        fontSize: 20,
        color: '#666', // Color del subtítulo
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      show: true,
      orient: 'horizontal',
      bottom: 'bottom',
    },
    grid: {
      top: '15%', // Ajusta el espacio desde la parte superior (debajo del título y la leyenda)
      bottom: '5%', // Deja un margen inferior pequeño
      left: '10%', // Margen izquierdo
      right: '10%', // Margen derecho
      containLabel: true, // Asegura que las etiquetas de los ejes no se corten
    },
    xAxis: {
      type: 'category',
      data: ['Agua', 'Cloaca', 'Otros'], // Nombres de las categorías
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        name: 'Servicios', // Nombre de la serie
        type: 'bar',
        data: [
          { value: 820, name: 'Agua', itemStyle: { color: '#ecfdff' } }, // mcm-blue-50
          { value: 932, name: 'Cloaca', itemStyle: { color: '#64e1fc' } }, // mcm-blue-300
          { value: 901, name: 'Otros', itemStyle: { color: '#144a65' } }, // mcm-blue-900
        ],
        emphasis: {
          focus: 'series',
        },
      },
    ],
  };

  chart!: ECharts;

  @Input() hasEvent = false;
  @Input() chartId: number = 0;

  @Output() update = new EventEmitter<number>();
  onChartInit(chart: any) {
    this.chart = chart;

    if (this.hasEvent) {
      this.chart.on('updateAxisPointer', (event: any) => {
        const xAxisIndex = event.axesInfo?.[0]?.value;
        this.update.emit(xAxisIndex);
      });
    }

    this.chart.on('click', (params: any) => {
      this.chartClick.emit(params);
    });

    this.setupResizeObserver();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (this.chart && !this.chart.isDisposed()) {
      this.chart.resize();
    }
  }

  hasData() {
    if (!this.chartOption) return;
    if (Object.keys(this.chartOption).length === 0) {
      return false;
    } else {
      return true;
    }
  }

  private setupResizeObserver() {
    if (typeof ResizeObserver === 'undefined') return;

    this.resizeObserver = new ResizeObserver(() => {
      if (this.chart && !this.chart.isDisposed()) {
        this.chart.resize();
      }
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }
}
